import { object } from 'prop-types'
import React from 'react'
import Icon from '../Icon'
import Type from '../Type'
import styles from './ContactConfirmation.module.scss'

const defaultFixture = {
  message: {
    header: 'Thank you for your request!',
    paragraph:
      'A member of our team will be in touch shortly. Thank you for your submission.'
  }
}

const ContactConfirmation = (props = defaultFixture) => {
  const { header, paragraph } = props.message
  return (
    <div className={styles.ContactConfirmation}>
      <Icon width={109} className={styles.Icon} type="tick" />
      <Type className={styles.Title} size="heading1" weight="medium">
        {header}
      </Type>
      <Type size="body1">{paragraph}</Type>
    </div>
  )
}

ContactConfirmation.propTypes = {
  message: object
}

ContactConfirmation.defaultProps = defaultFixture

export default ContactConfirmation
